import { Directive, HostListener, Input } from "@angular/core";
import moment from "moment";

@Directive({
	selector: "[dateTime]",
	standalone: false,
})
export class DateTimeDirective {
	@Input() dateTime: boolean;

	@HostListener("keydown", ["$event"])
	onKeyPress(event) {
		if (event.key !== "Backspace" || !this.dateTime) {
			return;
		}

		const input = event.target as HTMLInputElement;

		const value = input.value;

		if (value.slice(-1) === "/") {
			input.value = value.slice(0, -1);
		}
	}

	@HostListener("blur", ["$event"])
	onBlur(event) {
		const input = event.target as HTMLInputElement;
		const dateSeperated = input.value.split(/\/|\s|:/);
		const last = dateSeperated[dateSeperated.length - 1];
		if (dateSeperated.length !== 5) {
			return;
		}
		if (last.length === 1) {
			input.value += "0";
		} else if (last.length === 0) {
			input.value += "00";
		}
	}

	@HostListener("input", ["$event"])
	onInput(event: Event) {
		if (!this.dateTime) {
			return;
		}

		const input = event.target as HTMLInputElement;

		let dateInput = input.value;
		const dateSplitted = dateInput.split("");
		const dateSeperated = dateInput.split(/\/|\s|:/);
		const last = dateSplitted[dateSplitted.length - 1];
		const hasHours = dateSeperated.length >= 4 && dateSeperated[3] !== "";
		const hasMinutes = dateSeperated.length === 5 && dateSeperated[4] !== "";

		if (dateSeperated.length <= 3) {
			if (last && !last.match(/[0-9]|\//)) {
				dateSplitted.splice(dateSplitted.length - 1, 1);
				dateInput = dateSplitted.join("");
			}
		} else if (last && !last.match(/[0-9]|\/|\s|:/)) {
			dateSplitted.splice(dateSplitted.length - 1, 1);
			dateInput = dateSplitted.join("");
		}

		if (dateInput.length > 16) {
			dateInput = dateInput.substr(0, 16);
		}

		if (dateSplitted.length === 2 && dateSplitted[1] !== "/") {
			dateInput = `${dateInput}/`;
		}

		if (dateSplitted.length === 5 && dateSplitted[4] !== "/") {
			dateInput = `${dateInput}/`;
		}

		if (dateInput.length === 2 && dateSplitted[1] === "/") {
			dateInput = `0${dateInput}`;
		}
		if (dateInput.length === 5 && dateSplitted[4] === "/") {
			dateInput = `${dateSplitted[0]}${dateSplitted[1]}${dateSplitted[2]}0${dateSplitted[3]}${dateSplitted[4]}`;
		}

		if (Number(dateSeperated[0]) > 31) {
			dateSeperated[0] = "31";
			dateInput = `${dateSeperated.join("/")}/`;
		}

		if (Number(dateSeperated[1]) > 12) {
			dateSeperated[1] = "12";
			dateInput = `${dateSeperated.join("/")}/`;
		}

		if (dateSeperated.length === 3 && dateSeperated[2] !== "") {
			dateInput = this.isInvalidDate(dateInput, dateSeperated);
		}

		if (hasHours && Number(dateSeperated[3]) > 24) {
			dateInput = dateInput.slice(0, -1);
		}

		if (hasHours && dateSeperated.length === 5 && dateSeperated[3].length === 1) {
			const split = dateInput.split(/\s/);
			dateInput = `${split[0]} 0${split[1]}`;
		}

		if (hasHours && !hasMinutes && dateSeperated[3].length === 2 && last !== ":") {
			dateInput += ":";
		}

		if (hasMinutes && (Number(dateSeperated[4]) > 59 || dateSeperated[4].length > 2)) {
			dateInput = dateInput.slice(0, -1);
		}

		input.value = dateInput;
	}

	isInvalidDate(value: string, values: string[]) {
		const testDate = moment(value, "DD/MM/YYYY");
		if (testDate.isValid()) {
			return value;
		}

		const index = 2 - testDate.invalidAt();
		values[index] = `${Number(values[index]) - 1}`;
		if (values[2] === "02") {
			values[index] = "28";
		}

		return values.join("/");
	}
}
